import { render, staticRenderFns } from "./ArchiveCard.vue?vue&type=template&id=3d1069ca&scoped=true&"
import script from "./ArchiveCard.vue?vue&type=script&lang=ts&"
export * from "./ArchiveCard.vue?vue&type=script&lang=ts&"
import style0 from "./ArchiveCard.vue?vue&type=style&index=0&id=3d1069ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1069ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
